import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { moderationListSearchSchema } from '@/entities/moderation';
import {
  CategoriesModerationPage,
  createModerationParamsChange,
  moderationLoaderDeps,
  moderationRouteLoader,
  requireAuthBeforeLoad,
} from '@/pages/moderation';

/** Categories moderation queue — URL is the single source of truth for status/search/date/page. */
export const Route = createFileRoute('/moderation/categories')({
  staticData: { permission: 'moderation.categories.view' },
  beforeLoad: requireAuthBeforeLoad,
  validateSearch: moderationListSearchSchema,
  loaderDeps: moderationLoaderDeps,
  loader: moderationRouteLoader('categories'),
  component: CategoriesModerationRoute,
});

function CategoriesModerationRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onParamsChange = createModerationParamsChange(search, (options) => {
    void navigate(options);
  });

  return <CategoriesModerationPage params={search} onParamsChange={onParamsChange} />;
}
